const Selects = {
  default: {},
  variants: {
    filter: {
      field: {
        h: 8,
        fontSize: "sm",
        bg: "white",
        color: "black",
        fontWeight: 500,
        p: 1,
        borderRadius: "full",
      },
    },
    filterOperand: {
      field: {
        fontSize: "xs",
        h: 7,
        bg: "Secondary.100",
        color: "black",
        fontWeight: 500,
        p: 1,
        borderRadius: "base",
        mt: 0.5,
        mb: 0.5,
      },
      icon: {
        iconSize: "1rem",
      },
    },
  },
}

export default Selects
